export const environment = {
  production: true,
  sentryEnv: "staging",
  baseUrl: 'https://backend-staging.media-cert.fr',
  baseApiUrl: 'https://backend-staging.media-cert.fr/api',
  pageSize: 25,
};
